import {
  type Action,
  type Transfer,
  createGeneralActionsByTransfers,
} from '@0xtorch/core'
import type { BlockEvent, PolkadotSource } from '../../types'

type ConvertBroadcastSwapParameters = {
  timestamp: number
  source: PolkadotSource
  events: readonly BlockEvent[]
  transfers: readonly Transfer[]
  accountIds: Set<string>
  hasTransactionFeeAction: boolean
}

/**
 * broadcast.Swapped3 を、tx fee を除いた一対一の入出金から trade action へ変換する。
 *
 * @param params - event、transfer、action の生成に必要な情報。
 * @returns 一対一の入出金に集約できる場合は trade action、それ以外は `undefined`。
 */
export const convertBroadcastSwap = ({
  timestamp,
  source,
  events,
  transfers,
  accountIds,
  hasTransactionFeeAction,
}: ConvertBroadcastSwapParameters): readonly Action[] | undefined => {
  if (
    !hasTransactionFeeAction ||
    !events.some(
      (event) => event.section === 'broadcast' && event.method === 'Swapped3',
    )
  ) {
    return undefined
  }

  const actions = createGeneralActionsByTransfers({
    transfers,
    accountIds,
    source,
    timestamp,
  })
  if (actions.length !== 1) {
    return undefined
  }
  const action = actions[0]
  if (
    action === undefined ||
    action.type !== 'trade' ||
    action.transfers.filter((transfer) => transfer.direction === 'in')
      .length !== 1 ||
    action.transfers.filter((transfer) => transfer.direction === 'out')
      .length !== 1
  ) {
    return undefined
  }

  return [
    {
      ...action,
      evidence: 'contract',
    },
  ]
}
